export function generateFirestoreAutoId(length = 28) {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let id = '';
  
    for (let i = 0; i < length; i++) {
      id += chars.charAt(Math.floor(Math.random()   
   * chars.length));
    }
    return id;
  }